export const DURATION = 3e3
export const TOAST_MAX_WIDTH = 500
